import { useState } from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useAssociateDeviceMutation, useGetPontosenseTenantIdQuery } from '@/api';

export const useAddRadarSensorHandler = ({
  hubRecord,
  providerid,
  refetch,
  fetchDevices,
  queryParams,
}) => {
  const [isAddRadarSensorModalOpen, setIsAddRadarSensorModalOpen] = useState(false);
  const [homeId, setHomeId] = useState('');
  const trans = useSelector(translator);
  const { data: pontosenseTenantId } = useGetPontosenseTenantIdQuery(providerid);

  const openAddRadarSensorModal = () => setIsAddRadarSensorModalOpen(true);

  const closeAddRadarSensorModal = () => {
    setIsAddRadarSensorModalOpen(false);
    setHomeId('');
  };

  const associatePontosenseMutation = useAssociateDeviceMutation({
    onSuccess: () => {
      closeAddRadarSensorModal();
      message.success(trans('RADARSENSORADDEDSUCCESSFULLY'));
      refetch?.();
      fetchDevices?.(queryParams);
    },
    onError: () => {
      message.error(trans('FAILEDTOADDRADARSENSOR'));
    },
  });

  const submitAddRadarSensor = () => {
    if (!homeId) {
      return;
    }
    const pontosenseHomeId = Number(homeId);
    if (!Number.isFinite(pontosenseHomeId)) {
      return;
    }

    associatePontosenseMutation.mutate({
      homesight_useruuid: hubRecord?.useruuid,
      homesight_hubuuid: hubRecord?.hubid,
      homesight_deviceuuid: hubRecord?.deviceuuid,
      homesight_providerid: providerid,
      pontosense_tenant_id: pontosenseTenantId,
      pontosense_home_id: pontosenseHomeId,
    });
  };

  return {
    isAddRadarSensorModalOpen,
    openAddRadarSensorModal,
    closeAddRadarSensorModal,
    homeId,
    setHomeId,
    submitAddRadarSensor,
    isSubmitting: associatePontosenseMutation.isPending,
    submitError: associatePontosenseMutation.isError,
  };
};
